/**
 * 表单组件 和沃尔沃没区别
 */
import {mapGetters} from 'vuex'
import {CONSTANT as constant} from '@/services/constant';
import api from '@/services/api'

const formMixin = {
	name: 'formDetail',
	props: {
		// 主键prop和默认值
		rowId: {
			type: Number,
			default: -1
		},
	},
	data: function () {
		return {
			api,
			constant,
			params: this.$route.query,
			form: this.$form.createForm(this),
			formLoadBaseData: {},//表单加载成功的数据
			rules: this.dealFormRules(),
			entities: {},//详情数据
			keyId: -1,//主键
			// 表单控制变量
			formOption: {
				/**
				 * 加载/保存遮罩
				 */
				busy: false,
				loadProcess: true //加载审批流
			}
		};
	},
	watch: {
		/**
		 * 监听传入主键值的变化，触发更新
		 */
		rowId: {
			// 必须使用immediate才能接收到首次的值
			immediate: true,
			handler() {
				if (this.rowId !== -1) {
					//重置表单内容
					this.form.resetFields();
					//表单组件重置
					let $refsObj = this.$refs;
					for (let item in $refsObj) {
						if (Object.prototype.hasOwnProperty.call($refsObj, item)) {
							//子表
							if ($refsObj[item].$data.$refType === 'childTable') {
								this.$refs[item].loadData([]);
							}

							//富文本
							if ($refsObj[item].$data.$refType === 'editor') {
								this.$refs[item].setEditorData('');
							}

						}
					}


					this.beforeLoad(this).finally(() => {
						this._loadEntity(this.rowId);
					})
				}
			}
		}
	},
	/**
	 * 将当前用户加载到页面中
	 */
	computed: {
		...mapGetters('account', ['user'])
	},
	methods: {
		dealFormRules() {
			let rules = this.getRulesTemplate();
			// for (let rulesKey in rules) {
			// 	if(rules[rulesKey].rules){
			// 		rules[rulesKey].rules.forEach(item=>{
			// 			if(item.required){
			// 				item.whitespace = true;
			// 			}
			// 		})
			// 	}
			// }
			return rules;
		},

		/**
		 * 进度条
		 */
		loadProcess() {
			this.formOption.loadProcess = false;
			this.$nextTick(() => {
				this.formOption.loadProcess = true;
			})
		},
		/**
		 * 刷新
		 */
		refresh() {
			// this.$forceUpdate()
		},
		/**
		 * 表单处于加载状态
		 * @param status 布尔
		 */
		loading(status) {
			this.formOption.busy = status;
		},
		/**
		 * 组件给表单赋值回调（多用于赋值上传/富文本）
		 * @param ref 值从何来
		 * @param val 值
		 */
		setChangeFormValue(ref, val) {
			let obj = {};
			obj[ref] = val;
			//给表单选项赋值
			this.form.setFieldsValue(obj);
		},

		/**
		 * 给表单赋值
		 * @param obj
		 */
		setFormValue(obj) {
			if (!obj || !(obj instanceof Object)) {
				return console.warn('表单赋值参数不对 应该为对象');
			}
			this.form.setFieldsValue(obj);//赋值
		},
		/**
		 * 表单取值 输出一个值或一个对象
		 * @param any 字符串或数组或空 如果为空则输出整个表单
		 */
		getFormValue(any) {
			if (typeof any === 'string') {
				return this.form.getFieldValue(any);
			}
			if (any instanceof Array && any.length > 0) {
				return this.form.getFieldsValue(any);
			}
			return this.form.getFieldsValue();
		},

		/**
		 * 自定义保存 在原有保存基础上增加保存回调
		 * @param isPop 该表单是否是弹出层
		 * @param success 成功回调
		 * @param error 错误回调
		 * @param complete 完成回调
		 * @param other 自定义配置参数 可以在save 中调用
		 */
		async saveCustom({isPop = false, success = '', error = '', complete = '', other}) {
			await this._save(isPop, success, error, complete, other);
		},
		/**
		 * 给表单组件赋值 第一个参数可接收 对象
		 * @param ref
		 * @param value
		 */
		setRefsValue(ref, value) {
			try {
				if (arguments.length === 1 && typeof ref == "object" && ref) {//ref 如果是对象 会被for in循环解析 并重复赋值
					for (let item in ref) {
						if (Object.prototype.hasOwnProperty.call(ref, item)) {
							this.$refs[item].setFormChangeData(ref[item] || '');
						}
					}
				} else {// 不是对象则 第一个参数是ref 第二个是值
					this.$refs[ref].setFormChangeData(value || '');
					// setFormChangeData 的意思就是 调用的 名字叫ref的组件中的setFormChangeData方法
				}
			} catch (e) {
				console.info(e)
			}
		},
		/**
		 * 子表赋值
		 */
		setChildData(ref, data) {
			this.$refs[ref].loadData(data);
		},
		/**
		 * 富文本赋值
		 * @param ref
		 * @param data
		 */
		setEditorData(ref, data) {
			this.$refs[ref].setEditorData(data || '');
		},
		/**
		 * 文件上传赋值
		 * @param ref
		 * @param data
		 */
		setUploadData(ref, data) {
			this.$refs[ref].setUploadData(data || '');
		},
		/**
		 * 子表取值
		 */
		getChildData(ref, callback) {
			this.$refs[ref].getChildData((child, del) => {
				if (typeof callback === 'function') {
					callback(child, del)
				}
			})
		},

		/**
		 * 子表取值 callBack
		 */
		async getChildDataNew(ref) {
			return new Promise((resolve, reject) => {
				this.$refs[ref].$refs['grid'].$refs['xGrid'].validate().then(() => {
					this.$refs[ref].getChildData((child, del) => {
						resolve({child, del})
					});
				}).catch(e => {
					reject({msg: '必填项未填写完成', e})
				})
			})

			// return this.$refs[ref].$refs['grid'].$refs['xGrid'].validate().then(() => {
			// 	this.$refs[ref].getChildData((child, del) => {
			// 		return {child, del}
			// 		// resolve({child, del})
			// 	});
			// }).catch(e => {
			// 	return {msg: '必填项未填写完成', e}
			// 	// reject(e);
			// })
		},

		/**
		 * 简化的弹出选择封装
		 */
		selectPicker(res, ref) {
			if (res) {
				this.$refs[ref].getSelectData();
			}
			if (this.$refs[ref].$refs['grid'].$refs['xGrid'].$refs['formWrapper']) {
				this.$refs[ref].$refs['grid'].$refs['xGrid'].$refs['formWrapper'].getElementsByClassName('vxe-button')[1].click();
			}
		}
		,
		/**
		 * 完成选择的回调函数 固定写法
		 */
		choosePicker(ref) {
			this.$refs[ref].getSelectData();
		}
		,
		/**
		 * 清理选择器表格 固定写法
		 */
		clearPicker(ref) {
			this.$refs[ref].$refs['grid'].refresh();
		}
		,
		getTableData() {
			console.info('未定义弹出层选择的回调')
		}
		,
		/**
		 * 改变富文本编辑器的val
		 */
		changeEditorVal(ref, val) {
			let obj = {};
			obj[ref] = val;
			//给表单选项赋值
			this.form.setFieldsValue(obj);
		}
		,
		/**
		 * 改变文件上传input的值
		 */
		changeUploadVal(ref, val) {
			let obj = {};
			obj[ref] = val;
			//给表单选项赋值
			this.form.setFieldsValue(obj);
		}
		,
		/**
		 * 开始加载数据
		 * @param rowId 主键值
		 */
		_loadEntity(rowId) {
			// console.info("Loading entity", rowId);
			let vm = this;

			vm.formOption.busy = true;


			vm.loadBaseData().finally(async () => {

				this.keyId = rowId || '';//给主键赋值 用于取值
				// 根据是否有主键判断是新增还是编辑
				if (rowId) {


					// setTimeout(async function () {
					try {
						let res = await vm.loadEntity(rowId).catch(e => {
							console.log(e)
						});
						this.entities = res.data;
						vm._initForm(res.data);
					} finally {
						vm.$data.formOption.busy = false;
					}
					// }, 100);
				} else {
					// setTimeout(async function () {
					try {
						let res = await vm.newEntity();
						vm._initForm(res);
					} finally {
						vm.$data.formOption.busy = false;
					}
					// }, 100);
				}

				if (vm.$refs['process']) {
					vm.$refs['process'].loadWord(rowId, vm.params.businessNo).then(() => {
					});
				} else {
					console.info('无审批业务')
				}

			})
		}
		,
		/**
		 * 填充表单
		 * @param entity
		 */
		_initForm(entity) {
			// console.info("Initializing form", entity);
			this.initForm(entity);
		}
		,
		/**
		 * 提交数据
		 * @param isPop 该表单是否是弹出层（除非是直接跳转的明细页表单 其他的都是弹出层）
		 * @param success 成功回调
		 * @param error 错误回调
		 * @param complete 完成回调
		 * @param other 其他处理
		 */
		async _save(isPop = true, success, error, complete, other) {
			this.formOption.busy = true;

			let data;
			this.form.validateFieldsAndScroll((err, values) => {
				if (!err) {//无任何错误 向下执行
					data = values;
				} else {
					data = null;
				}
			});


			// 必填项未填写完成
			if (!data) {
				this.formOption.busy = false;
				return "必填项未填写完成";
			} else {
				for (let item in data) {
					if (Object.prototype.hasOwnProperty.call(data, item)) {
						//undefined 转 空字符串
						if (data[item] === undefined) {
							data[item] = '';
						}
						//字符串去除前后空格
						if (typeof data[item] === 'string') {
							try {
								if (this.form.formItems[item].$attrs.trim !== false) {
									data[item] = data[item].trim();
								}
							} catch (e) {
								console.log(e)
							}
						}
						//数组转 ,分隔字符串
						if (data[item] && Array.isArray(data[item])) {
							data[item] = data[item].join(',');
						}
						//布尔转 1 0
						if (typeof data[item] === 'boolean') {
							data[item] = data[item] ? 1 : 0;
						}
					}
				}
			}
			// console.log(data)
			Object.assign(data,{
				createDate:this.entities.createDate||'',
				createUserId:this.entities.createUserId||'',
				lastModifyDate:this.entities.lastModifyDate||'',
				lastModifyUserId:this.entities.lastModifyUserId||'',
			})


			this.save(data, this, other)
					.then(() => {
						this.formOption.busy = false;
						if (typeof success === 'function') {//是否有自定义
							success();
						} else {
							// 保存成功
							this.$message.success('操作成功')
							if (isPop) {
								this.$emit('closePop');
								// this.rowId = -1;
							} else {
								this.endEdit('saved');
								// this.rowId = -1;
							}
						}
					})
					.catch(e => {
						this.formOption.busy = false;
						if (typeof e === 'string') {
							return this.$message.error(e);
						}
						if (typeof error === 'function') {//是否有自定义
							console.error('保存错误回调：错误信息：', e);
							error(e);
						} else {
							if (e && typeof e.msg === 'string') {
								// this.$message.error(e.msg);
							} else if (e.response?.response?.data?.msg) {
								this.$message.error(e.response.response.data.msg);
							} else {
								this.$message.error('数据保存有误，请联系管理员');
							}
						}
					})
					.finally(() => {
						// this.formOption.busy = false;
						if (typeof complete === 'function') {//是否有自定义
							complete();
						}
					});
		}
		,
		/**
		 * 绑定基础数据
		 */
		async loadBaseData() {
			console.warn("页面暂无基础数据");
			return new Promise((resolve, reject) => {
				try {
					resolve({});
				} catch (e) {
					reject(e);
				}
			})
		}
		,
		/**
		 * 关闭明细页或弹出层
		 * @param isPop true为弹出层 false为明细页
		 */
		close(isPop = false) {
			if (isPop) {
				this.$emit('closePop')
			} else {
				this.endEdit('cancelled')
			}
		},
		/**
		 * 编辑完成后通知父组件
		 * @param evt
		 */
		endEdit(evt) {
			//这里清除掉了弹出层内的默认值以及弹出子表内的选中数据
			this.beforeClose().finally(() => {
				this.$emit(evt, this.rowId);
			})
		},

		/**
		 * 获取表单的约束
		 */
		getRulesTemplate() {
			console.error("页面暂无表单约束");
		}
		,


		/**
		 * 加载数据
		 * @param rowId 主键值
		 * @returns {Promise}
		 */
		loadEntity(rowId) {
			console.error("未实现methods.loadEntity", rowId);
		}
		,
		/**
		 * 新建表单数据
		 * @returns {Object}
		 */
		newEntity() {
			console.error("未实现methods.newEntity");
		}
		,
		/**
		 * 初始化表单
		 * @param entity
		 */
		initForm(entity) {
			// console.error("未实现methods.initForm", entity);
			let obj = this.form.getFieldsValue();//获取表单项
			for (let item in obj) {
				if (Object.prototype.hasOwnProperty.call(obj, item)) {
					if (obj[item] instanceof Object) {//如果是对象 使用赋值
						for (let inItem in obj[item]) {//二级对象防止报错
							if (Object.prototype.hasOwnProperty.call(obj[item], inItem)) {
								obj[item][inItem] = entity[item] ? entity[item][inItem] : ''
							}
						}
					} else {
						obj[item] = entity[item];
					}
				}
			}
			// console.log(obj)
			this.form.setFieldsValue(obj);//赋值
			this.formLoadBaseData = entity;
			this.afterLoad(entity);//执行加载完成函数
		}
		,
		/**
		 * 提交数据
		 * @param entities 这里的主表数据不带主键 需要拼接
		 * @param vm
		 * @param other
		 * @returns {Promise}
		 */
		save(entities, vm, other) {
			console.error("未实现methods.save", entities, vm, other);
		}
		,
		/**
		 * 加载数据之前执行的函数
		 * @returns {Promise}
		 */
		beforeLoad(vm) {
			console.warn("不包含加载前函数", vm);
			return new Promise(resolve => {
				resolve()
			})
		}
		,
		/**
		 * 加载数据后执行的函数
		 */
		afterLoad(entity) {
			console.warn("不包含加载后函数", entity);
		}
		,
		/**
		 * 关闭操作之前执行的函数
		 * @returns {Promise}
		 */
		beforeClose() {
			console.warn("不包含关闭操作之前执行的函数");
			return new Promise(resolve => {
				resolve()
			})
		}
	}
}

export {
	formMixin
}
